<template>
	<div class="home-page">
		<div class="shortcut">
			<ul>
				<li class="shortcut-li shadow">
					<div class="title">员工档案管理</div>
					<div class="shortcut-li-hover">
						<router-link to="/personalInfo" class="link">
							<el-button>员工档案管理</el-button>
						</router-link>
						<router-link to="/department" class="link">
							<el-button>部门管理</el-button>
						</router-link>
					</div>
					<img src="../assets/img/quick-icon01.png" class="img" />
				</li>
				<li class="shortcut-li shadow">
					<div class="title">工资管理</div>
					<div class="shortcut-li-hover">
						<router-link to="/payroll" class="link">
							<el-button>工资管理</el-button>
						</router-link>
						<!-- <router-link :to="{name:'payroll',query:{insureDialogVisible:true}}" class="link"><el-button>调整保险费</el-button></router-link> -->
						<router-link to="/sysSetting" class="link">
							<el-button>调整保险费</el-button>
						</router-link>
					</div>
					<img src="../assets/img/quick-icon02.png" class="img" />
				</li>
				<li class="shortcut-li shadow">
					<div class="title">基础信息管理</div>
					<div class="shortcut-li-hover">
						<router-link to="/jobGrade" class="link">
							<el-button>岗位级别管理</el-button>
						</router-link>
						<router-link to="/mealGrade" class="link">
							<el-button>饭补级别设置</el-button>
						</router-link>
						<router-link to="/insureGrade" class="link">
							<el-button>社保级别设置</el-button>
						</router-link>
						<router-link to="/insureCompany" class="link">
							<el-button>入保企业设置</el-button>
						</router-link>
						<router-link to="/sysSetting" class="link">
							<el-button>其他设置</el-button>
						</router-link>
					</div>
					<img src="../assets/img/quick-icon03.png" class="img" />
				</li>
			</ul>
		</div>
		<div class="info shadow">
			<div class="title">
				<span>人资基本信息</span>
				<em>＊下标数据为对比去年同期</em>
			</div>
			<ul class="info-icon">
				<li class="info-icon-li" v-for="(item,index) in infoList" :key="index">
					<div class="content">
						<div class="left">
							<div class="icon-title">{{item.title}}</div>
							<div class="text">
								<span>{{item.number}}</span>
								<i v-if="index==1">元</i>
								<i v-if="index==3">个</i>
								<i v-if="index!==1&&index!==3">人</i>
								<em :class="{'green':item.rise<=0,'red':item.rise>0}"><em
										v-if="item.rise>0">+</em>{{item.rise}}</em>
							</div>
						</div>
						<img :src="require('../assets/img/home-icon0'+(index+1)+'.png')" class="img" />
						<ul class="content-hover" v-if="item.list">
							<li v-for="(item,index) in item.list" :key="index">
								<span v-if="!item.company">未选择参保公司：</span>
								<span v-else>{{ item.company }}：</span>
								<span><em>{{ item.count }}</em>人</span>
							</li>
						</ul>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script setup>
	import {
		onMounted,
		ref
	} from "vue";
	const infoList = ref([{
		title: '当前职工数',
		number: 265,
		rise: 56
	}, {
		title: '保险扣款',
		number: 265,
		rise: -156
	}, {
		title: '车补人数',
		number: 265,
		rise: -20
	}, {
		title: '下属部门',
		number: 265,
		rise: 56
	}, {
		title: '参保人数',
		number: 265,
		rise: 56,
		list: []
	}, {
		title: '饭补人数',
		number: 265,
		rise: 56
	}])

	onMounted(() => {
		getHomeData()
	})

	import {
		fetchHomeData
	} from '@/api/report'
	const getHomeData = () => {
		fetchHomeData().then(res => {
			let data = res.data
			infoList.value[0].number = data.personCount
			infoList.value[0].rise = data.newPersonCount
			infoList.value[1].number = data.insuranceFee.toFixed(2)
			infoList.value[1].rise = (data.insuranceFee - data.lastInsuranceFee).toFixed(2)
			infoList.value[2].number = data.carCount
			infoList.value[2].rise = data.newCarCount
			infoList.value[3].number = data.departmentCount
			infoList.value[3].rise = data.newDepartmentCount
			infoList.value[4].number = data.insuranceCount
			infoList.value[4].rise = data.newInsuranceCount
			infoList.value[4].list = data.insuranceCountList
			infoList.value[5].number = data.mealCount
			infoList.value[5].rise = data.newMealCount
		})
	}
</script>

<style lang="scss" scoped>
	pages {
		background-color: #F4F7FE;
	}

	.home-page {
		max-width: 1420px;
		margin: 10vh auto;
		padding: 0 20px;

		.shortcut {
			ul {
				display: flex;
				justify-content: space-between;
			}

			.shortcut-li {
				width: 31%;
				box-sizing: border-box;
				background: #FFF;
				border-radius: 16px;
				position: relative;
				overflow: hidden;
				cursor: pointer;

				&:hover {
					.shortcut-li-hover {
						display: flex;
					}

					.title {
						color: #FFF;
					}
				}

				.shortcut-li-hover {
					display: none;
					background: rgba($color:#377DFF, $alpha:0.9);
					position: absolute;
					left: 0;
					right: 0;
					top: 0;
					bottom: 0;
					z-index: 1000;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					padding-top: 20px;

					.link {
						width: 65%;
					}

					.el-button {
						width: 100%;
						margin: 5px;
						color: #377DFF;
						font-size: 16px;
						height: 40px;
					}
				}

				.title {
					position: absolute;
					left: 40px;
					top: 28px;
					color: #202020;
					font-size: 16px;
					font-weight: bold;
					z-index: 1001;
				}

				.img {
					display: block;
					margin: 3% auto 0;
					max-width: 100%;
				}
			}
		}

		.info {
			background: #FFF;
			border-radius: 16px;
			margin: 4vh 0 0 0;
			padding: 40px;

			.title {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin: 0 0 40px 0;

				span {
					color: #202020;
					font-size: 16px;
					font-weight: bold;
				}

				em {
					color: #404040;
					font-size: 12px;
				}
			}

			.info-icon {
				display: flex;
				flex-wrap: wrap;

				.info-icon-li {
					width: 33.3%;
					box-sizing: border-box;
					padding: 0 0 30px 0;
					border-right: 1px solid #C0C0C0;
					display: flex;

					&:nth-child(3n+1) {}

					&:nth-child(3n+2) {
						justify-content: center;
					}

					&:nth-child(3n+3) {
						justify-content: flex-end;
						border-right: none;
					}

					&:nth-child(4),
					&:nth-child(5),
					&:nth-child(6) {
						padding: 0;
					}

					.content {
						background-color: #F4F7FE;
						border-radius: 8px;
						width: 70%;
						box-sizing: border-box;
						padding: 15px;
						display: flex;
						align-items: center;
						justify-content: space-between;
						position: relative;
						overflow: hidden;

						&:hover {
							.content-hover {
								display: flex;
							}
						}

						.content-hover {
							display: none;
							background: rgba($color:#377DFF, $alpha:0.8);
							position: absolute;
							left: 0;
							right: 0;
							top: 0;
							bottom: 0;
							z-index: 1000;
							align-items: center;
							flex-wrap: wrap;
							padding: 5px 10px;
							color: #FFF;
							overflow-y: auto;

							li {
								width: 50%;
								font-size: 12px;
								line-height: 16px;

								em {
									font-size: 16px;
									font-weight: bold;
									color: $main-light-color;
								}
							}
						}
					}

					@media (max-width:1200px) {
						.content-hover li {
							width: 100% !important;
						}
					}

					.left {
						.icon-title {
							color: #808080;
							font-size: 14px;
						}

						.text {
							font-size: 16px;

							span {
								font-size: 24px;
								color: #202020;
								font-weight: bold;
							}

							i {
								color: #404040;
							}

							em {
								margin: 0 0 0 5px;
							}

							.green {
								color: #34CF10;
							}

							.red {
								color: red;
							}
						}
					}
				}
			}
		}
	}
</style>
